import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// Zustand is the single source of truth for language. We read the persisted
// language directly from localStorage on init so i18n and Zustand start in
// the same state (default 'pt'). Avoids race conditions between async
// LanguageDetector (navigator/htmlTag) and Zustand hydration that caused
// the "PT flag but EN content" bug.
const getInitialLng = () => {
  try {
    const stored = localStorage.getItem('locale-store');
    if (stored) {
      const parsed = JSON.parse(stored);
      const lang = parsed?.state?.language;
      if (lang && ['pt', 'pt-BR', 'en', 'es', 'fr'].includes(lang)) {
        return lang;
      }
    }
  } catch (e) {
    // localStorage unavailable or invalid JSON — fall through to default
  }
  return 'pt';
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getInitialLng(),
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'pt-BR', 'en', 'es', 'fr'],
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/translation.json?v=3',
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },
  });

export default i18n;
